// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__sM6jS","title":"AfterFrontImage_title__3EVap"};